/**
 * Utilitário para sincronizar dados de autenticação no localStorage
 * Execute uma vez para corrigir dados existentes
 */

export function syncLocalStorageAuth() {
  console.log('🔄 Sincronizando dados de autenticação...');
  
  try {
    const userInfo = localStorage.getItem('userInfo');
    const user = localStorage.getItem('user');
    
    if (userInfo && !user) {
      // Criar dados de user baseado no userInfo
      const userInfoData = JSON.parse(userInfo);
      
      const userData = {
        access_token: 'temp_token_' + Date.now(), // Token temporário
        token_type: 'bearer',
        email: userInfoData.email,
        role: userInfoData.role ? userInfoData.role.toLowerCase() : 'patient',
        id: userInfoData.id,
        name: userInfoData.name
      };
      
      localStorage.setItem('user', JSON.stringify(userData));
      console.log('✅ Dados de user criados:', userData);
      
      // Normalizar role no userInfo também
      if (userInfoData.role) {
        userInfoData.role = userInfoData.role.toLowerCase();
        localStorage.setItem('userInfo', JSON.stringify(userInfoData));
        console.log('✅ Role normalizado no userInfo');
      }
      
      return true;
    } else if (user && userInfo) {
      // Sincronizar roles se necessário
      const userData = JSON.parse(user);
      const userInfoData = JSON.parse(userInfo);
      
      let updated = false;
      
      // Normalizar role no user
      if (userData.role && userData.role !== userData.role.toLowerCase()) {
        userData.role = userData.role.toLowerCase();
        updated = true;
      }
      
      // Normalizar role no userInfo
      if (userInfoData.role && userInfoData.role !== userInfoData.role.toLowerCase()) {
        userInfoData.role = userInfoData.role.toLowerCase();
        updated = true;
      }
      
      // Sincronizar role entre user e userInfo
      if (userInfoData.role && (!userData.role || userData.role !== userInfoData.role)) {
        userData.role = userInfoData.role;
        updated = true;
      }
      
      if (updated) {
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('userInfo', JSON.stringify(userInfoData));
        console.log('✅ Dados sincronizados');
      }
      
      return updated;
    }
    
    return false;
  } catch (error) {
    console.error('❌ Erro ao sincronizar dados:', error);
    return false;
  }
}

export function getCurrentAuthState() {
  const user = localStorage.getItem('user');
  const userInfo = localStorage.getItem('userInfo');
  
  return {
    user: user ? JSON.parse(user) : null,
    userInfo: userInfo ? JSON.parse(userInfo) : null,
    hasUser: !!user,
    hasUserInfo: !!userInfo,
    isLoggedIn: !!(user || userInfo)
  };
}

export function validateAuthData() {
  const state = getCurrentAuthState();
  
  const issues = [];
  
  if (!state.hasUser && !state.hasUserInfo) {
    issues.push('Nenhum dado de autenticação encontrado');
  }
  
  if (state.hasUserInfo && !state.hasUser) {
    issues.push('userInfo encontrado mas user está ausente');
  }
  
  if (state.user && !state.user.role) {
    issues.push('user não tem role definido');
  }
  
  if (state.userInfo && !state.userInfo.role) {
    issues.push('userInfo não tem role definido');
  }
  
  if (state.user?.role && state.userInfo?.role && state.user.role !== state.userInfo.role) {
    issues.push('Role inconsistente entre user e userInfo');
  }
  
  return {
    isValid: issues.length === 0,
    issues,
    state
  };
}

// Auto-executar sincronização se necessário
export function autoSyncAuth() {
  const validation = validateAuthData();
  
  if (!validation.isValid) {
    console.log('🔍 Problemas de autenticação detectados:', validation.issues);
    
    if (syncLocalStorageAuth()) {
      console.log('✅ Sincronização automática concluída');
      return true;
    }
  }
  
  return false;
}

export default {
  syncLocalStorageAuth,
  getCurrentAuthState,
  validateAuthData,
  autoSyncAuth
};
